var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDegreeSpeaker360(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 19.5C12.5523 19.5 13 19.9477 13 20.5L13 22C13 22.5523 12.5523 23 12 23C11.4477 23 11 22.5523 11 22L11 20.5C11 19.9477 11.4477 19.5 12 19.5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 1C12.5523 1 13 1.44772 13 2L13 3.5C13 4.05228 12.5523 4.5 12 4.5C11.4477 4.5 11 4.05228 11 3.5L11 2C11 1.44772 11.4477 1 12 1Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2571 12C20.5293 12.4039 19.678 12.7594 18.7298 13.0543C19.0564 13.1719 19.3644 13.2972 19.652 13.429C21.6819 14.3594 22 15.239 22 15.5C22 15.761 21.6819 16.6406 19.652 17.571C17.7968 18.4212 15.0934 19 12 19C8.90663 19 6.2032 18.4212 4.34803 17.571C2.31814 16.6406 2 15.761 2 15.5C2 15.239 2.31814 14.3594 4.34803 13.429C4.63561 13.2972 4.94358 13.1719 5.27022 13.0543C4.322 12.7594 3.47074 12.4039 2.7429 12C1.02942 12.9509 0 14.1704 0 15.5C0 18.5376 5.37258 21 12 21C18.6274 21 24 18.5376 24 15.5C24 14.1704 22.9706 12.9509 21.2571 12Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.652 10.571C21.6819 9.64059 22 8.76104 22 8.5C22 8.23896 21.6819 7.35941 19.652 6.42904C17.7968 5.57875 15.0934 5 12 5C8.90663 5 6.2032 5.57875 4.34803 6.42904C2.31814 7.35941 2 8.23896 2 8.5C2 8.76104 2.31814 9.64059 4.34803 10.571C6.2032 11.4212 8.90663 12 12 12C15.0934 12 17.7968 11.4212 19.652 10.571ZM12 14C18.6274 14 24 11.5376 24 8.5C24 5.46243 18.6274 3 12 3C5.37258 3 0 5.46243 0 8.5C0 11.5376 5.37258 14 12 14Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 12C19.5523 12 20 12.4477 20 13L20 15C20 15.5523 19.5523 16 19 16C18.4477 16 18 15.5523 18 15L18 13C18 12.4477 18.4477 12 19 12Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 12C5.55228 12 6 12.4477 6 13L6 15C6 15.5523 5.55228 16 5 16C4.44772 16 4 15.5523 4 15L4 13C4 12.4477 4.44772 12 5 12Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 3C5.55228 3 6 3.44772 6 4L6 8C6 8.55228 5.55228 9 5 9C4.44772 9 4 8.55228 4 8L4 4C4 3.44772 4.44772 3 5 3Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 3C19.5523 3 20 3.44772 20 4L20 8C20 8.55228 19.5523 9 19 9C18.4477 9 18 8.55228 18 8L18 4C18 3.44772 18.4477 3 19 3Z",
    fill: "currentColor"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 7C12.5523 7 13 7.44772 13 8L13 10C13 10.5523 12.5523 11 12 11C11.4477 11 11 10.5523 11 10L11 8C11 7.44772 11.4477 7 12 7Z",
    fill: "currentColor"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 13C12.5523 13 13 13.4477 13 14L13 16C13 16.5523 12.5523 17 12 17C11.4477 17 11 16.5523 11 16L11 14C11 13.4477 11.4477 13 12 13Z",
    fill: "currentColor"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 18C19.5523 18 20 18.4477 20 19L20 21C20 21.5523 19.5523 22 19 22C18.4477 22 18 21.5523 18 21L18 19C18 18.4477 18.4477 18 19 18Z",
    fill: "currentColor"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 18C5.55228 18 6 18.4477 6 19L6 21C6 21.5523 5.55228 22 5 22C4.44772 22 4 21.5523 4 21L4 19C4 18.4477 4.44772 18 5 18Z",
    fill: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDegreeSpeaker360);
export default __webpack_public_path__ + "static/media/degree_speaker_360.70b4158690558c60c77f9f0665ea07c4.svg";
export { ForwardRef as ReactComponent };